import React, { type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import type { Appearance, Spacing } from '@atlaskit/button/types';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages.tsx';

type ExternalLinkButtonProps = Intl & {
	href: string;
	children: string;
	appearance?: Appearance;
	spacing?: Spacing;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onClick: ((e: SyntheticEvent<any>, analyticsEvent: UIAnalyticsEvent) => void) | undefined;
	showShortcutIcon: boolean;
};

export const ExternalLinkButton = ({
	href,
	children,
	intl,
	onClick,
	appearance,
	spacing,
	showShortcutIcon,
}: ExternalLinkButtonProps) => (
	<Tooltip tag="span" content={intl.formatMessage(messages.opensInNewWindow)} position="mouse">
		<Button
			href={href}
			appearance={appearance}
			target="_blank"
			spacing={spacing}
			onClick={onClick}
			iconAfter={
				showShortcutIcon ? (
					<Box xcss={iconContainerStyles}>
						<ShortcutIcon
							LEGACY_size="small"
							label={intl.formatMessage(messages.opensInNewWindow)}
						/>
					</Box>
				) : undefined
			}
		>
			{children}
		</Button>
	</Tooltip>
);

ExternalLinkButton.defaultProps = {
	onClick: undefined,
	showShortcutIcon: true,
	appearance: 'link' as const,
	spacing: 'none' as const,
};

export default injectIntl(ExternalLinkButton);

const iconContainerStyles = xcss({
	marginLeft: 'space.100',
});
